module.exports = __webpack_public_path__ + "images/pages/for_business/pc/btn_2_d12d243b01a1f02f343d80e7b1d1ae64.png";